const initCardStack = () => {
    const prepareCardStack = (container: HTMLElement, options = null) => {
        const {
            spacing = 88,
            scaleStep = 0.12,
            minScale = 0.4
        } = options;

        const cards = container.children;
        const totalCards = cards.length;

        if (totalCards < 3) return;

        const track = document.createElement('div');
        track.insertAdjacentHTML('beforeend', container.innerHTML);

        container.innerHTML = '';
        container.insertAdjacentElement('afterbegin', track);

        const uid = Math.random().toString(36).substring(2, 9);

        let css = '';
        for (let cardIndex = 0; cardIndex < totalCards; cardIndex++) {
            let frames = [];

            const numSteps = Math.max(totalCards * 2, 20);

            for (let step = 0; step <= numSteps; step++) {
                const percent = (step / numSteps) * 100;
                const activeFloat = (step / numSteps) * (totalCards - 1);
                const distanceFromActive = cardIndex - activeFloat;
                const y = distanceFromActive * spacing;

                const absDistance = Math.abs(distanceFromActive);
                const scale = Math.max(minScale, 1 - absDistance * scaleStep);

                const yOffset = y - (76 / 2);

                frames.push(
                    `${percent.toFixed(1)}% { 
                        transform: translateX(-50%) translateY(${yOffset.toFixed(1)}px) scale(${scale.toFixed(3)});
                    }`
                );
            }

            css += `@keyframes card-${uid}-${cardIndex} { ${frames.join(' ')} }\n`;

            css += `[data-stack-id="${uid}"] > div > *:nth-child(${cardIndex + 1}) {
                    --card-keyframes: card-${uid}-${cardIndex};
                }\n`;
        }

        container.setAttribute('data-stack-id', uid);

        const style = document.createElement('style');
        style.textContent = css;
        document.head.appendChild(style);
    }

    document.querySelectorAll('.wp-block-group.is-style-stack').forEach(prepareCardStack)
}

export default initCardStack